export default {
  pageTitle: 'Batch setting of price',
  methodPrice: 'Price setting method',
  radio1: 'All in same discount',
  radio2: 'All add or minus same amount',
  radio3: 'All in same price',
  setting1: 'Setting of all in same percentage of price',
  setting2: 'Setting of all add or minus same amount',
  setting3: 'Setting of all in same price',
  content: `Only supports integers, the range is 1-99. After the price is
    calculated, it is rounded down with decimals. If you want all in 20%
    discount, you need to enter 80. If the price is calculated as 23.9,
    it will be priced at 23. Please remember to check the price after
    setting.`,
  content2: `That is, add or subtract a set value from the sales price. For
    example,-30 means that all selected products price will be reduced
    by 30 for each sku as the promotion price. The platform does not
    recommend the use of raise price. If you raise price the product
    cant be in Today's Deal and Flashsale. If the actual price exceeds
    the original sale price after calculation, your application will be
    denied. Please remember to check the price after setting.`,
  content3: `All selected products will be set to the specified price. Please be
    very careful to use this setting. Please remember to check the price
    after setting.`,
  confirmAndSubmit: 'Confirm the price setting and submit',
  main1: 'goods applied successfully',
  main2: 'The following failed to apply',
  main3: 'listing ID',
  main4: 'SKU ID',
  main5: 'Msg',
  main6: '个报名成功',
  error1: '输入1-99的整数',
  tips: 'Are you sure to confirm',
  error2: 'Please fill in the uniform price setting'
}
